/* One conservative online composition rule. It is not an engraver specification. */
(() => {
  'use strict';
  if (window.tfInscriptionRules) return;
  const maxLines = 7;
  // Width is in the 1194px photographic reference. The inset leaves metal clear
  // beside both edges and the chain holes; only the upper half receives text.
  const safeWidth = 338;
  const font = '26px "JetBrains Mono", monospace';
  let context;
  const measure = value => {
    if (!context) context = document.createElement('canvas').getContext('2d');
    if (!context) return Array.from(value).length * 14;
    context.font = font;
    return context.measureText(value).width;
  };
  const inspect = value => {
    const lines = String(value ?? '').replace(/\r\n?|\u2028|\u2029/gu, '\n').split('\n');
    const tooLong = lines.findIndex(line => measure(line) > safeWidth);
    return { lines, lineCount: lines.length, tooMany: lines.length > maxLines, tooLong: tooLong < 0 ? 0 : tooLong + 1, valid: lines.length <= maxLines && tooLong < 0 };
  };
  const bindings = new WeakMap();
  // Stop extra explicit lines at entry, without trimming or rewriting text.
  // Existing over-limit saved values remain visible and can be reduced normally.
  const bindInput = (input, onRejected) => {
    if (bindings.has(input)) return bindings.get(input);
    let previous = input.value;
    let selection = [input.selectionStart, input.selectionEnd];
    const reject = () => queueMicrotask(() => onRejected?.());
    const exceeds = value => {
      const count = inspect(value).lineCount;
      return count > maxLines && count > inspect(input.value).lineCount;
    };
    const replacement = text => input.value.slice(0, input.selectionStart) + text + input.value.slice(input.selectionEnd);
    const before = event => {
      previous = input.value;
      selection = [input.selectionStart, input.selectionEnd];
      const text = ['insertLineBreak', 'insertParagraph'].includes(event.inputType) ? '\n' : event.data;
      if (typeof text === 'string' && exceeds(replacement(text)) && event.cancelable) {
        event.preventDefault();
        reject();
      }
    };
    const paste = event => {
      const text = event.clipboardData?.getData('text/plain');
      if (typeof text !== 'string' || !exceeds(replacement(text))) return;
      event.preventDefault();
      reject();
    };
    const changed = event => {
      const count = inspect(input.value).lineCount;
      if (event.isTrusted && count > maxLines && count > inspect(previous).lineCount) {
        input.value = previous;
        input.setSelectionRange(...selection);
        reject();
      } else previous = input.value;
    };
    input.addEventListener('beforeinput', before);
    input.addEventListener('paste', paste);
    input.addEventListener('input', changed);
    const unbind = () => {
      input.removeEventListener('beforeinput', before);
      input.removeEventListener('paste', paste);
      input.removeEventListener('input', changed);
      bindings.delete(input);
    };
    bindings.set(input, unbind);
    return unbind;
  };
  window.tfInscriptionRules = Object.freeze({ maxLines, safeWidth, font, inspect, bindInput });
})();
